import { useMemo } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';

type ChartItem = {
  /** 識別キー（内部用、X 軸ラベルではない） */
  step: string;
  /** X 軸表示ラベル（登録 / CA面談 / 書類選考 / 1次選考 ...） */
  label: string;
  /** バーの値 */
  value: number;
};

type Props = {
  items: ChartItem[];
};

export default function DashboardFunnelBarChart({ items }: Props) {
  const data = useMemo(() => items.map((it) => ({ label: it.label, value: it.value })), [items]);

  return (
    <div className="w-full [&_.recharts-surface:focus:not(:focus-visible)]:outline-hidden [&_.recharts-wrapper_*:focus:not(:focus-visible)]:outline-hidden [&_.recharts-wrapper:focus:not(:focus-visible)]:outline-hidden">
      <ResponsiveContainer width="100%" height={184}>
        <BarChart data={data} margin={{ top: 24, right: 0, left: 0, bottom: 0 }}>
          {/* 水平グリッド線のみ */}
          <CartesianGrid stroke="#e5e7eb" vertical={false} />
          {/* X 軸 */}
          <XAxis
            dataKey="label"
            tick={{ fontSize: 12, fill: '#6d6d6d' }}
            axisLine={false}
            tickLine={false}
            interval={0}
          />
          {/* Y 軸 */}
          <YAxis
            tick={{ fontSize: 12, fill: '#88898b' }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => v.toLocaleString()}
            allowDecimals={false}
            width={50}
          />
          {/* バー本体 + 値ラベル */}
          <Bar dataKey="value" fill="#005fff" radius={[4, 4, 0, 0]} maxBarSize={50}>
            <LabelList
              dataKey="value"
              position="top"
              offset={6}
              fill="#005fff"
              fontSize={14}
              fontWeight={700}
              formatter={(value: unknown) =>
                typeof value === 'number' ? value.toLocaleString() : String(value ?? '')
              }
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
